// User roles (admin can manage users; viewer can only read dashboard)
export const UserRole = {
    Admin: "admin",
    Viewer: "viewer",
};
export const USER_ROLES = [UserRole.Admin, UserRole.Viewer];
// Mouse trap event types (1-byte event codes from the binary protocol)
export const EventType = {
    LidOpened: 0x01,
    LidClosed: 0x02,
    MouseCaughtLeft: 0x03,
    MouseCaughtRight: 0x04,
    LowBattery: 0x05,
};
export const EVENT_TYPE_LABELS = {
    [EventType.LidOpened]: "Lid opened",
    [EventType.LidClosed]: "Lid closed",
    [EventType.MouseCaughtLeft]: "Mouse caught (left)",
    [EventType.MouseCaughtRight]: "Mouse caught (right)",
    [EventType.LowBattery]: "Low battery",
};
export function eventTypeLabel(code) {
    return EVENT_TYPE_LABELS[code] ?? `Unknown (0x${code.toString(16).padStart(2, "0")})`;
}
//# sourceMappingURL=enums.js.map